import { GalaxyConfig, StarData, StarPosition } from 'types/galaxy';

export const calculateSunflowerPositions = (
  starsData: StarData[],
  _config: GalaxyConfig
): StarPosition[] => {
  const goldenAngle = Math.PI * (3 - Math.sqrt(5));
  const maxR = 75;

  // Sort by PnL descending (center = best)
  const sorted = starsData.map((_, i) => i).sort((a, b) => starsData[b].pnl - starsData[a].pnl);
  const count = sorted.length;
  const positions: StarPosition[] = new Array(count);

  sorted.forEach((idx, rank) => {
    const angle = rank * goldenAngle;
    const r = maxR * Math.sqrt(rank / count) + (Math.random() - 0.5) * 1.5;
    const t = rank / count;
    const y = (1 - t) * 8 - 4 + (Math.random() - 0.5) * 1;

    positions[idx] = {
      x: Math.cos(angle) * r,
      y,
      z: Math.sin(angle) * r,
    };
  });

  return positions;
};
